import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { AutoComplete } from 'primereact/autocomplete';
import ReactSelectPagination from '../global/ReactSelectPagination';
import { getNestedValue, isEmpty } from '../../services/functions';
import { useTooltipPortal } from '../global/TooltipPortal';
import "./prime_table.scss"



export const BodyWrapper = ({ item, options, errors, disabled, parentKey, children, placeholder, validate = false,showInputPlaceholder=false }) => {
  const index = options.rowIndex;
  const field= options?.column?.props?.cellConfig?.cellField ?? options.field
  
  const innerKey = `${index}.${field}`;
  const path = `${parentKey ? `${parentKey}.` : ''}${innerKey}`;
  const nestedValue = getNestedValue(item, field);
  
  const isValueEmpty = isEmpty(nestedValue) || nestedValue === undefined;
  const inputRef = useRef(null);
  const { showTooltip, hideTooltip } = useTooltipPortal();

  const handlePointerEnter = useCallback(
    (event) => {
      event.stopPropagation();
      const errorMessage = errors[path].message;
      if (errorMessage) {
        showTooltip(inputRef, errorMessage);
      }
    },
    [errors, path, showTooltip]
  );

  const handlePointerLeave = useCallback(
    (event) => {
      event.stopPropagation();
      hideTooltip();
    },
    [hideTooltip]
  );

  if (validate && errors?.[path]) {
    const divProps = errors[path]?.isCustom
      ? { onPointerEnter: handlePointerEnter, onPointerLeave: handlePointerLeave }
      : {};

    return (
      <div {...divProps}>
        <input
          ref={inputRef}
          value={item[options.field] || ''}
          placeholder={placeholder}
          className="form-control form-control-sm is-invalid"
          style={options?.column?.props?.style ?? {}}
          disabled={disabled}
        />
      </div>
    );
  } else if (isValueEmpty) {
    return (
      <InputText
        placeholder={placeholder}
        disabled={disabled}
        style={options?.column?.props?.style ?? {}}
      />
    );
  }
  else if(showInputPlaceholder){
    return <InputPlaceholder>
      {children}
    </InputPlaceholder>
  }

  return children ?? ' ';
};

const editor = (props) => {
  const { col, cellOptions, disabled, t, addItem, onChange,setValidationErrors,validationErrors,parentKey } = props;
  const cellConfig = col?.cellConfig ?? {};
  const currentValue = cellOptions?.value ?? '';
  const style={...cellOptions.column?.props?.style}
  const cellInpuOnChange=cellConfig?.onChange

  const handleChange = (key, value) => {
    if (cellInpuOnChange){
      cellInpuOnChange({ key, value, cellOptions });
      cellOptions.editorCallback(value);
    }else if (onChange) {
      const newValue = onChange({ key, value, cellOptions });
      cellOptions.editorCallback(newValue ?? value);
    } 
    cellOptions.editorCallback(value);
    if(validationErrors && setValidationErrors){
      const index=cellOptions.rowIndex
      const innerKey=  `${index}.${cellOptions.field}`
      const path =`${parentKey ?`${parentKey}.`:""}${innerKey}`
      if(validationErrors[path]){
        setValidationErrors((errors)=>({...errors,[path]:null}))
      }
    }
  };

  const field = cellConfig?.cellField ?? col?.field
  switch (cellConfig?.type) {

    case 'TEXTAREA': {
      const { onChange: _, ...configWithoutOnChange } = cellConfig;
      return (
        <textarea
          placeholder={t('item.description')}
          disabled={disabled}
          onChange={(e) => handleChange(field, e.target.value)}
          rows={currentValue?.length > 22 ? 3 : 1}
          className="form-control form-control-sm"
          value={currentValue}
          style={style}
          {...configWithoutOnChange}
        />
      );
    }

    case 'AUTOCOMPLETE': {
      const { loadOptions,suggestions=[],onSelect, onChange: _, ...configWithoutOnChange } = cellConfig;
      return (
        <div className="createInvoice-tableInputs">
          <AutoComplete
            className='custom-grid-cell'
            disabled={disabled}
            value={currentValue}
            suggestions={suggestions}
            completeMethod={(e) => loadOptions(e.query)}
            field="label"
            onChange={(e) => {
              console.log({test:e})
              if (typeof e.value === 'string') {
                handleChange(field, e.value);
              }
            }}
            inputStyle={style}
            {...configWithoutOnChange}
            onSelect={(e) => onSelect({ e, cellOptions })}
          />
        </div>
      );
    }

    case 'REACT-SELECT-PAGINATION': {
      const { optionLabel = 'label', optionValue = 'value', onChange: _, ...configWithoutOnChange } = cellConfig;
      return (
        <ReactSelectPagination
          styles={cellConfig.uomStyle}
          isDisabled={disabled}
          value={currentValue}
          onChange={(value) => handleChange(field, value)}
          getOptionLabel={(option) => option[optionLabel]}
          getOptionValue={(option) => option[optionValue]}
          {...configWithoutOnChange}
        />
      );
    }
    case 'DROPDOWN': {
      const { onChange: _, ...configWithoutOnChange } = cellConfig;
      return (
      <Dropdown
          value={currentValue}
          className='w-full'
          disabled={disabled}
          onChange={(e) => handleChange(field, e.value)}
          {...configWithoutOnChange}
         />
      )
    }

    case 'CHECKBOX': {
      const { onChange: _, ...configWithoutOnChange } = cellConfig;
      return (
        <Checkbox
          checked={currentValue}
          disabled={disabled}
          onChange={(e) => handleChange(field, e.checked)}
          {...configWithoutOnChange}

        />
      );
    }

    default: {
      const { onChange: _, ...configWithoutOnChange } = cellConfig;
      return (
        <InputText
          disabled={disabled}
          onChange={(e) => handleChange(field, e.target.value)}
          value={currentValue}
          {...configWithoutOnChange}
          style={style}
        />
      );
    }
  }
};


export const InputPlaceholder=({children})=>{
  return <div className='input-placeholder p-inputtext' style={{height:31.19}}>
    {children}
  </div>
}

export default editor;